import classNames from 'classnames';
import { useAtomValue } from 'jotai';
import { RefObject } from 'react';
import { twMerge } from 'tailwind-merge';

import { isMobile } from '@growtherapy/analytics';

import { localScreenShareContextAtom } from '../../core/room/participant/media/atoms';
import { LocalScreenShareComponentProps, RemoteScreenShareComponentProps } from '../../core/types';

export function ZoomLocalScreenShare({ videoRef }: LocalScreenShareComponentProps) {
  const { delegator } = useAtomValue(localScreenShareContextAtom);
  const isMobileDevice = isMobile(navigator.userAgent);
  const className = twMerge(
    classNames('relative max-w-full sm:w-unset fs-exclude display-block max-h-full', { 'sm:w-full': isMobileDevice }),
  );
  const testId = 'screenshare-video';

  const usesVideoElement = delegator ? delegator.usesVideoElement() : false;

  return (
    <div className='w-full h-full flex items-center justify-center'>
      {usesVideoElement ? (
        <video // eslint-disable-line  jsx-a11y/media-has-caption
          className={className}
          data-testid={testId}
          ref={videoRef as RefObject<HTMLVideoElement>}
        />
      ) : (
        <canvas className={className} data-testid={testId} ref={videoRef as RefObject<HTMLCanvasElement>} />
      )}
    </div>
  );
}

/**
 * Screen share must use a different parent video-player-container
 */
export function ZoomRemoteScreenShare({ videoRef }: RemoteScreenShareComponentProps) {
  return (
    <video-player-container class='w-[min(100vw,1280px)]'>
      <video-player data-testid='screenshare-video' style={{ width: '100%' }} ref={videoRef} />
    </video-player-container>
  );
}
